import React, { createContext, useCallback, useState, useEffect } from 'react';
import { getCurrentUser } from '../api/users';
import { useAuth } from './AuthContext';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { logout, isLoggedIn, ready } = useAuth();

  const fetchUser = useCallback(async () => {
    setLoading(true);
    try {
      const user = await getCurrentUser();
      setCurrentUser(user.user);
      setError(null);
    } catch (error) {
      setError(error);
      setCurrentUser(null);
      logout();
    } finally {
      setLoading(false);
    }
  }, [logout]);

  useEffect(() => {
    if (ready && isLoggedIn) {
      fetchUser();
    } else if (ready) {
      setCurrentUser(null);
      setLoading(false);
    }
  }, [ready, isLoggedIn, fetchUser]);

  return (
    <UserContext.Provider value={{ currentUser, setCurrentUser, loading, error , fetchUser }}>
      {children}
    </UserContext.Provider>
  );
};
